import { FC } from 'react';
import { Tooltip } from '@components/Tooltip/Tooltip';
import { Link, useLocation } from 'react-router-dom';
import { twMerge } from '@utils/twMerge';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';

type InventoryNavItemProps = {
  path: string;
  title: string;
};
export const InventoryNavItem: FC<InventoryNavItemProps> = ({
  path,
  title,
}) => {
  const { pathname } = useLocation();
  const isActiveLink = pathname.includes(path);
  return (
    <div className={'hover:bg-waterLight cursor-pointer h-[4rem]'}>
      <Tooltip title={title} mouseEnterDelay={0.5}>
        <Link
          to={path}
          className={twMerge(
            'flex w-full h-full text-1624 font-semibold text-dimGray',
            isActiveLink && 'text-dodgerBlue'
          )}
        >
          <div className={'flex flex-1 items-center justify-between px-3'}>
            <div className={'whitespace-nowrap'}>{title}</div>
            {isActiveLink ? <ChevronIcon dir='right' className={'text-dodgerBlue'} /> : <div className={'w-2'}></div>}
          </div>
        </Link>
      </Tooltip>
    </div>
  );
};
